var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    "aria-hidden": "true",
    viewBox: "0 0 14 14",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 7c.827 0 1.5-.673 1.5-1.5S5.127 4 4.3 4s-1.5.673-1.5 1.5S3.473 7 4.3 7m6.6-2.4H6.7a.3.3 0 0 0-.3.3v2.7H2.2V3.7a.3.3 0 0 0-.3-.3h-.6a.3.3 0 0 0-.3.3v6.6a.3.3 0 0 0 .3.3h.6a.3.3 0 0 0 .3-.3v-.9h9.6v.9a.3.3 0 0 0 .3.3h.6a.3.3 0 0 0 .3-.3V6.7a2.1 2.1 0 0 0-2.1-2.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.e8fae72fcfdcad2a9e51c7bf1ccc72c8.svg";
export { ForwardRef as ReactComponent };